import { axios } from '@/utils/request'

const api = {
  info: '/basicdata/info',
  type: '/system/dict/type',
}

// const api = {
//   installLabel: '/master/installLabel',
// }
//
// export function queryInstallLabel (parameter) {
//   return axios({
//     url: api.installLabel + '/queryInstallLabel',
//     method: 'get',
//     params: parameter
//   })
// }

export function getInfoList (parameter) {
  return axios({
    url: api.info + '/list',
    method: 'get',
    params: parameter
  })
}

export function getList (parameter) {
  return axios({
    url: api.type + '/list',
    method: 'get',
    params: parameter
  })
}

// export function saveChannel (parameter) {
//   return axios({
//     url: api.info+(parameter.channelId == 0 ? '/save' : '/update'),
//     method: 'post',
//     data: parameter,
//     headers: {
//       'Content-Type': 'application/json;charset=UTF-8'
//     }
//   })
// }

export function remove (parameter) {
  return axios({
    url: api.info + '/remove',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//新建
export function save (parameter) {
  return axios({
    url: api.info + '/save',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

//编辑
export function update (parameter) {
  return axios({
    url: api.info + '/update',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export const remindMap = {
  '0': '是',
  '1': '否'
}

export const fieldType = {
  '0': '单选框',
  '1': '输入框',
  '3': '单选+输入'
}

export const channelExport = api.channel + '/export'
